/* eslint-disable no-alert */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Collapse, Input } from 'reactstrap';
import axios from 'supports/api';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import TimePicker from 'react-time-picker';

const ProgramDetailFilters = ({
  programFilters,
  setProgramFilters,
  defaultProgramFilters,
}) => {
  const [filterOpen, setFilterOpen] = useState(false);

  const [branches, setBranches] = useState([]);
  const [studyMethods, setStudyMethods] = useState([]);
  const [studySchedules, setStudySchedules] = useState([]);

  const getBranches = useCallback(() => {
    axios
      .get(`/branch/all`)
      .then((res) => {
        setBranches(res.data.result);
      })
      .catch((err) => {
        alert(err.message);
      });
  }, []);

  useEffect(() => {
    getBranches();
  }, [getBranches]);

  const branchOptions = useMemo(() => {
    return branches.map((branch) => ({
      value: branch.id,
      label: branch.name,
    }));
  }, [branches]);

  const getStudyMethods = useCallback(() => {
    axios
      .get(`/program/methods`)
      .then((res) => {
        setStudyMethods(res.data.result);
      })
      .catch((err) => {
        alert(err.message);
      });
  }, []);

  useEffect(() => {
    getStudyMethods();
  }, [getStudyMethods]);

  const studyMethodOptions = useMemo(() => {
    return studyMethods.map((studyMethod) => ({
      value: studyMethod.id,
      label: studyMethod.name,
    }));
  }, [studyMethods]);

  const getStudySchedules = useCallback(() => {
    axios
      .get(`/program/schedules`)
      .then((res) => {
        setStudySchedules(res.data.result);
      })
      .catch((err) => {
        alert(err.message);
      });
  }, []);

  useEffect(() => {
    getStudySchedules();
  }, [getStudySchedules]);

  const studyScheduleOptions = useMemo(() => {
    return studySchedules.map((studySchedule) => ({
      value: studySchedule.id,
      label: studySchedule.name,
    }));
  }, [studySchedules]);

  return (
    <div className="border-left border-bottom border-right border-top">
      <div>
        <button
          type="button"
          className="btn btn-sm btn-secondary my-2 dropdown-toggle btn-collapse-pym"
          onClick={() => setFilterOpen(!filterOpen)}
        >
          Filter by
        </button>
      </div>
      <Collapse isOpen={filterOpen}>
        <div className="row container pb-3">
          <div className="col-12 col-md-6">
            <div className="font-weight-bold" style={{ fontSize: '12px' }}>
              Search Program Code
            </div>
            <Input
              onChange={(event) => {
                setProgramFilters({
                  ...programFilters,
                  code: event.target.value,
                });
              }}
              value={programFilters.code}
              placeholder="Program Code"
            />
          </div>

          <div className="col-12 col-md-6">
            <div className="font-weight-bold" style={{ fontSize: '12px' }}>
              Branch(es)
            </div>
            <Select
              isMulti
              options={branchOptions}
              name="branchIds"
              value={programFilters.branchIds}
              onChange={(e) => {
                setProgramFilters({
                  ...programFilters,
                  branchIds: e,
                });
              }}
            />
          </div>

          <div className="col-12 col-md-6 mt-2">
            <div className="font-weight-bold" style={{ fontSize: '12px' }}>
              Start Date Month
            </div>
            <DatePicker
              className="form-control"
              selected={programFilters.startDateMonth}
              onChange={(pickedDate) =>
                setProgramFilters({
                  ...programFilters,
                  startDateMonth: pickedDate,
                })
              }
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              showFullMonthYearPicker
              placeholderText="Select Month"
            />
          </div>

          <div className="col-12 col-md-6 mt-2">
            <div className="font-weight-bold mb-1" style={{ fontSize: '12px' }}>
              Training Session Start Time
            </div>
            <TimePicker
              onChange={(e) =>
                setProgramFilters({ ...programFilters, startTime: e })
              }
              value={programFilters.startTime}
            />
          </div>

          <div className="col-12 col-md-6 mt-2">
            <div className="font-weight-bold" style={{ fontSize: '12px' }}>
              Study Method(s)
            </div>
            <Select
              isMulti
              options={studyMethodOptions}
              name="studyMethodIds"
              value={programFilters.studyMethodIds}
              onChange={(e) => {
                setProgramFilters({
                  ...programFilters,
                  studyMethodIds: e,
                });
              }}
            />
          </div>

          <div className="col-12 col-md-6 mt-2">
            <div className="font-weight-bold" style={{ fontSize: '12px' }}>
              Study Schedules(s)
            </div>
            <Select
              isMulti
              options={studyScheduleOptions}
              name="studyScheduleIds"
              value={programFilters.studyScheduleIds}
              onChange={(e) => {
                setProgramFilters({
                  ...programFilters,
                  studyScheduleIds: e,
                });
              }}
            />
          </div>

          <div className="col-12 mt-2 d-flex justify-content-end">
            <Button
              className="rounded ml-1 my-1 ml-auto"
              onClick={() => setProgramFilters(defaultProgramFilters)}
              color="danger"
            >
              Reset Filters
            </Button>
          </div>
        </div>
      </Collapse>
    </div>
  );
};

export default ProgramDetailFilters;
